import React from "react";
import { useTranslation } from "react-i18next";
import { ContextHelp } from "../../ui";

/**
 * ConversationFilters component for filtering and searching conversations
 * @param {Object} props - Component props
 * @param {string} props.statusFilter - Currently active status filter
 * @param {Function} props.onStatusFilterChange - Callback when status filter changes
 * @param {string} props.statusReasonFilter - Currently active status reason filter
 * @param {Function} props.onStatusReasonFilterChange - Callback when status reason filter changes
 */
const ConversationFilters = ({
  statusFilter,
  onStatusFilterChange,
  statusReasonFilter,
  onStatusReasonFilterChange,
}) => {
  const { t } = useTranslation("conversations");

  const statusOptions = [
    { value: "all", label: t("filters.status.all") },
    { value: "active", label: t("filters.status.active") },
    { value: "closed", label: t("filters.status.closed") },
    { value: "writing", label: t("filters.status.writing") },
  ];

  const statusReasonOptions = [
    { value: "all", label: t("filters.reason.all") },
    { value: "completed", label: t("filters.reason.completed") },
    { value: "abandoned", label: t("filters.reason.abandoned") },
    { value: "failed", label: t("filters.reason.failed") },
  ];

  return (
    <div className="flex flex-1 flex-col gap-4 sm:flex-row">
      {/* Status Filter */}
      <div className="flex-shrink-0">
        <div className="flex items-center gap-2">
          <select
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            className="custom-select block h-10 w-full rounded-md border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
          >
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ContextHelp
            className="h-3.5 w-3.5"
            ariaLabel={t("help.filters.status.ariaLabel")}
            whatIs={t("help.filters.status.whatIs")}
          />
        </div>
      </div>

      {/* Status Reason Filter */}
      <div className="flex-shrink-0">
        <div className="flex items-center gap-2">
          <select
            value={statusReasonFilter}
            onChange={(e) => onStatusReasonFilterChange(e.target.value)}
            className="custom-select block h-10 w-full rounded-md border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
          >
            {statusReasonOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ContextHelp
            className="h-3.5 w-3.5"
            ariaLabel={t("help.filters.reason.ariaLabel")}
            whatIs={t("help.filters.reason.whatIs")}
          />
        </div>
      </div>
    </div>
  );
};

export default ConversationFilters;
